import { render } from "./pointListNew.vue?vue&type=template&id=c29f029c&scoped=true"
import script from "./pointListNew.vue?vue&type=script&lang=js"
export * from "./pointListNew.vue?vue&type=script&lang=js"

import "./pointListNew.vue?vue&type=style&index=0&id=c29f029c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c29f029c"]])

export default __exports__